import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/shop/tocc_-cheong-so-nyeon-yong_-geom-sa1743251787bfdd.png?type=myboard&data_idx=942731&col_num=21&dir_name=sub2_2&thum_w=600&thum_h=600&thum_cut_yn=0'
import _imports_1 from '@/assets/img/shop/tocc_-ji-chim-seo174339713338f7.png?type=myboard&data_idx=942731&col_num=27&dir_name=sub2_2&thum_w=600&thum_h=600&thum_cut_yn=0'
import _imports_2 from '@/assets/img/shop/1_tocc_-a-dong-yongn-cheong-so-nyeo1739928583fb63.jpg?type=myboard&data_idx=942731&col_num=26&dir_name=sub2_2&thum_w=600&thum_h=600&thum_cut_yn=0'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-read-wrap" }
const _hoisted_5 = { class: "btn" }

import BoardNavbar from "@/views/product/testing/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { USER_ROUTES } from "@/assets/route_constants.ts";

export default /*@__PURE__*/_defineComponent({
  __name: 'Teen',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "진단검사",
      subtitle: "진단검사",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(BoardNavbar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "sub_subject" }, "TOCC창의역량검사", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("figure", null, [
              _createVNode(_component_n_space, { justify: "center" }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("img", {
                    src: "#",
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("h1", null, [
              _createElementVNode("span", null, " 창의적 성취역량 성장 지표로서의"),
              _createTextVNode(" 창의역량검사_청소년용 ")
            ], -1)),
            _cache[2] || (_cache[2] = _createElementVNode("figure", { class: "img_wrap" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }),
              _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              })
            ], -1))
          ]),
          _cache[8] || (_cache[8] = _createStaticVNode("<div data-v-8662dd62><h2 data-v-8662dd62>검사 정보</h2><ul data-v-8662dd62><li data-v-8662dd62><dl data-v-8662dd62><dt data-v-8662dd62>저자</dt><dd data-v-8662dd62>강정하 ·김아영</dd></dl></li><li data-v-8662dd62><dl data-v-8662dd62><dt data-v-8662dd62>대상</dt><dd data-v-8662dd62>중1 – 고3</dd></dl></li><li data-v-8662dd62><dl data-v-8662dd62><dt data-v-8662dd62>검사유형</dt><dd data-v-8662dd62>자기보고식 검사</dd></dl></li><li data-v-8662dd62><dl data-v-8662dd62><dt data-v-8662dd62>문항수</dt><dd data-v-8662dd62>80 문항</dd></dl></li><li data-v-8662dd62><dl data-v-8662dd62><dt data-v-8662dd62>소요시간</dt><dd data-v-8662dd62>15분 – 30분</dd></dl></li><li data-v-8662dd62><dl data-v-8662dd62><dt data-v-8662dd62>가격</dt><dd data-v-8662dd62>(검사코드) 11,000원 <br data-v-8662dd62>(진단 지침서) 11,000원</dd></dl></li></ul><div class=\"bg\" data-v-8662dd62><div data-v-8662dd62><h3 data-v-8662dd62><span data-v-8662dd62>저자</span>강정하</h3><p data-v-8662dd62> (주)COKOLab. 대표이사<br data-v-8662dd62> 성균관대학교 아동청소년학과 겸임교수<br data-v-8662dd62> 성균관대학교 영재교육원 부원장 (현) 한성손재한장학회 고문<br data-v-8662dd62> 이화여자대학교 교육심리학 학사, 석사<br data-v-8662dd62> 성균관대학교 영재 및 창의성 교육 전공 박사<br data-v-8662dd62> Corcoran School of the Arts in George Washington Univ. 수학 </p></div><div data-v-8662dd62><h3 data-v-8662dd62><span data-v-8662dd62>저자</span>김아영</h3><p data-v-8662dd62> 이화여자대학교 심리학과 명예교수<br data-v-8662dd62> 한국교육 &amp; 심리연구소 소장<br data-v-8662dd62> 이화여자대학교 교육심리학과 학사<br data-v-8662dd62> 미국 University of Iowa 교육측정 및 통계 MA<br data-v-8662dd62> 미국 University of Iowa 교육심리 Ph.D. </p></div></div></div><div data-v-8662dd62><h2 data-v-8662dd62>TOCC창의역량검사의 목적</h2><p data-v-8662dd62> 본 검사는 ‘모든 사람의 창의역량’을 총체적, 다원적으로 측정하는 검사로, 개인의 특별한 경험을 발굴, 확장, 극대화함으로써 행복한 현재 삶은 물론 미래 기회를 창조하도록 지원하는 데 목적이 있다. </p></div><div data-v-8662dd62><h2 data-v-8662dd62>TOCC창의역량검사의 특징</h2><p data-v-8662dd62> 첫째, 21세기 시대정신–진화론·양자역학·다원적 우주관·역량평가–에 기반을 두고 있다.<br data-v-8662dd62> 둘째, 개인 역량의 성장, 발현을 주도하는 세상으로 열린 경험을 측정한다.<br data-v-8662dd62> 셋째, 개인의 내외적 발달과 변화에 민감하게 반응하는 위계적 시스템의 자기조직화 수준을 측정한다.<br data-v-8662dd62> 넷째, 개인과 환경과의 변화로 인한 위계적 시스템의 양호도를 측정하여 그 성장가능성을 예측한다. </p></div><div data-v-8662dd62><h2 data-v-8662dd62>TOCC창의역량검사의 구성</h2><p data-v-8662dd62> 본 검사는 3역량군9역량20세부역량으로 구성된다. 3역량군은 개인역량군, 실재역량군, 사회역량군으로, 개인역량군에는 경험, 인지, 정서 역량이, 실재역량군에는 지식, 문제, 자원 역량이, 사회역량군에는 지지, 소통, 평가 역량이 속한다. 총 9역량이다. 9역량 각각은 다시 1 ~ 3세부역량씩, 총 20세부역량으로 이루어져 있다. 모든 문항은 9역량 영역의 특수맥락을 반영하는 활동지표이다. </p></div>", 4)),
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("h2", null, "TOCC창의역량검사의 발달단계별 구분", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("p", null, [
              _createTextVNode(" 본 검사는 학령기를 창의역량 발달 3단계–아동용·청소년용·전문가용–로 구분, 측정한다. "),
              _createElementVNode("br"),
              _createTextVNode(" TOCC_청소년용은 중학생과 고등학생을 대상으로 한다. 검사의 20세부역량 대부분은 학구적, 탐구적, 분석적이고, 뚜렷한"),
              _createElementVNode("br"),
              _createTextVNode(" 목표의식, 책임감, 적응적, 리더쉽 등을 특징을 띤다. 이는 총 80문항으로 구성된다. ")
            ], -1)),
            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("figure", null, [
              _createVNode(_component_n_space, { justify: "center" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Product.Coaching.Tocc.Path}`
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("목록")
              ])),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ])
  ]))
}
}

})